import { create } from 'zustand';
import { saveAs } from 'file-saver';
import { ApiUtils } from '@shared/utils';
import { CardsApi, RequestStrategyEnum } from '@shared/api';

interface UseDownloadStatementStore {
  loading: boolean;
  success: boolean | null;
  error: string | null;
  downloadStatement: (id: string, token: string, signal?: AbortSignal) => Promise<void>;
  clear: () => void;
}

export const useDownloadStatementStore = create<UseDownloadStatementStore>((set) => ({
  loading: false,
  error: null,
  success: null,

  downloadStatement: ApiUtils.wrapperApi(async (id, token, signal) => {
    try {
      set({ loading: true, error: null, success: null });
      const result = await CardsApi.downloadStatement(id, token, signal);
      saveAs(result, 'statement.pdf');
      set({ loading: false, success: true });
    } catch (error) {
      set({ error: ApiUtils.getApiError(error), loading: false, success: false });
    }
  }, RequestStrategyEnum.Debounce),

  clear: () => set({ loading: false, error: null, success: null }),
}));
